import { $appendTo, $el, $find, $qs, $remove } from 'fxdom/es';
import { go, tap } from 'fxjs/es';
import { NessLabsTmplS } from '../../S/Tmpl/module/NessLabsTmplS.js';
import { MShopUtilF } from '../../../MShop/Util/F/Function/module/MShopUtilF.js';

const labs_loader_component = '.ness-labs-loader';

export const labs_loader = {
  tasks: [], // 로딩 중에 대기 되어야할 작업들 (로딩 이후 실행 되어야할 작업들)
  start: function (timeout) {
    // resetBrowserMetaTheme(true);
    const before_don_loader_wrap_el = $qs(labs_loader_component);
    if (before_don_loader_wrap_el) {
      return;
    }
    this.tasks = [];
    body_fixed(true);

    return go(
      NessLabsTmplS.labsLoaderTmpl(),
      $el,
      $appendTo($qs('body')),
      tap(() => {
        if (timeout) {
          setTimeout(() => {
            this.end();
          }, timeout);
        }
      }),
    );
  },
  end: function () {
    resetBrowserMetaTheme();
    body_fixed(false);
    const don_loader_wrapper = $find(labs_loader_component, $1('body'));
    if (don_loader_wrapper) $remove(don_loader_wrapper);
    this.runTask();
  },
  addTask: function (...task) {
    this.tasks.push(...task);
  },
  runTask: async function (is_reset = true) {
    for (const task of this.tasks) {
      await task();
    }
    if (is_reset) this.tasks = [];
  },
};

export const resetBrowserMetaTheme = (dark_mode = false) => {
  if (!MShopUtilF.isMobile()) return;

  const theme_color = dark_mode ? '#565656' : '#FFFFFe';
  const existingMeta = $qs('meta[name="theme-color"]');
  if (!existingMeta) {
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = theme_color;
    document.getElementsByTagName('head')[0].appendChild(meta);
  } else {
    existingMeta.content = theme_color;
  }
};

export const body_fixed = (is_fixed) => {
  if (is_fixed) document.body.classList.add('maple-labs-loading__body-fixed');
  else document.body.classList.remove('maple-labs-loading__body-fixed');
};
